import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
export function SuccessStories() {
  const stories = [{
    title: 'From VP to CEO',
    desc: 'A Vice President of Operations at a Fortune 500 company sought their next chapter. Within 4 months, they secured a CEO position at a high-growth firm.',
    result: 'CEO Placement | 40% Comp Increase'
  }, {
    title: 'The Hidden Opportunity',
    desc: 'A seasoned CFO was unaware of a transformative opportunity at a pre-IPO company. Through our hidden market access, they discovered and secured the role.',
    result: 'Pre-IPO CFO | Equity Package Secured'
  }, {
    title: 'Career Reinvention',
    desc: 'After 20 years in financial services, a senior leader sought to transition into the nonprofit sector. Boardline guided the pivot to an Executive Director appointment.',
    result: 'Sector Transition | Executive Director'
  }];
  return <Section background="navy" id="stories" className="relative overflow-hidden" data-id="element-418">
      {/* Subtle background texture */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" data-id="element-419">
        <div className="absolute inset-0 bg-gradient-to-b from-accent-400/10 via-transparent to-accent-400/5" data-id="element-420" />
      </div>

      <div className="relative z-10" data-id="element-421">
        {/* Centered header */}
        <FadeIn className="text-center mb-16 max-w-3xl mx-auto" data-id="element-422">
          <h2 className="text-3xl md:text-4xl font-serif text-sage-50 mb-4" data-id="element-423">
            Boardline Success Stories
          </h2>
          <div className="w-16 h-[2px] bg-accent-400 mx-auto mb-8" data-id="element-424" />
          <p className="text-lg md:text-xl text-sage-300 leading-relaxed font-light" data-id="element-425">
            Every client who partners with Boardline secures their next
            executive role. Here are just a few of the career transformations
            we've delivered.
          </p>
        </FadeIn>

        {/* Story cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-426">
          {stories.map((story, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-427">
              <div className="bg-sage-50 h-full flex flex-col relative" data-id="element-428">
                {/* Outer frame border */}
                <div className="absolute inset-0 border border-sage-300/60" data-id="element-429" />
                {/* Inner frame border */}
                <div className="absolute inset-[6px] border border-sage-200/50" data-id="element-430" />

                {/* Card content */}
                <div className="relative z-10 p-8 md:p-10 flex flex-col flex-grow" data-id="element-431">
                  <h3 className="text-2xl font-serif italic text-ink-900 mb-5 leading-snug" data-id="element-432">
                    {story.title}
                  </h3>

                  <p className="text-body text-sm leading-relaxed flex-grow mb-8" data-id="element-433">
                    {story.desc}
                  </p>

                  {/* Result badge */}
                  <div className="mt-auto" data-id="element-434">
                    <span className="inline-block bg-ink-900 text-sage-50 text-[10px] font-bold uppercase tracking-[0.15em] px-4 py-2.5" data-id="element-435">
                      {story.result}
                    </span>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </Section>;
}